import { useState } from "react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import { Label } from "./ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";
import { submitItinerary } from "../lib/api";

const empty = {
  name: "",
  phone: "",
  email: "",
  destination: "",
  travelers: 2,
  budget: "",
  travel_dates: "",
  special_requests: "",
};

export default function ItineraryForm() {
  const [form, setForm] = useState(empty);
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((s) => ({ ...s, [k]: e?.target ? e.target.value : e }));

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await submitItinerary({ ...form, travelers: Number(form.travelers) });
      toast.success("Itinerary request received. We'll be in touch within 24 hours.");
      setForm(empty);
    } catch (err) {
      toast.error("Could not submit. Please try again or WhatsApp us.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="grid sm:grid-cols-2 gap-4" data-testid="itinerary-form">
      <div className="grid gap-2">
        <Label htmlFor="name">Full Name</Label>
        <Input id="name" required value={form.name} onChange={set("name")} data-testid="itin-name" placeholder="Ananya Sharma" />
      </div>
      <div className="grid gap-2">
        <Label htmlFor="phone">Phone</Label>
        <Input id="phone" required value={form.phone} onChange={set("phone")} data-testid="itin-phone" placeholder="+91" />
      </div>
      <div className="grid gap-2 sm:col-span-2">
        <Label htmlFor="email">Email</Label>
        <Input id="email" type="email" required value={form.email} onChange={set("email")} data-testid="itin-email" placeholder="you@email.com" />
      </div>
      <div className="grid gap-2">
        <Label>Destination</Label>
        <Select value={form.destination} onValueChange={set("destination")}>
          <SelectTrigger data-testid="itin-destination"><SelectValue placeholder="Select" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="Meghalaya">Meghalaya</SelectItem>
            <SelectItem value="Assam">Assam</SelectItem>
            <SelectItem value="Arunachal Pradesh">Arunachal Pradesh</SelectItem>
            <SelectItem value="Multi-state">Multi-state North East</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="travelers"># Travelers</Label>
        <Input id="travelers" type="number" min={1} required value={form.travelers} onChange={set("travelers")} data-testid="itin-travelers" />
      </div>
      <div className="grid gap-2">
        <Label>Budget (per person)</Label>
        <Select value={form.budget} onValueChange={set("budget")}>
          <SelectTrigger data-testid="itin-budget"><SelectValue placeholder="Select" /></SelectTrigger>
          <SelectContent>
            <SelectItem value="Under ₹20k">Under ₹20,000</SelectItem>
            <SelectItem value="₹20k–₹40k">₹20,000 – ₹40,000</SelectItem>
            <SelectItem value="₹40k–₹80k">₹40,000 – ₹80,000</SelectItem>
            <SelectItem value="₹80k+">₹80,000 +</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="dates">Travel Dates</Label>
        <Input id="dates" required value={form.travel_dates} onChange={set("travel_dates")} data-testid="itin-dates" placeholder="e.g. 12 – 19 March" />
      </div>
      <div className="grid gap-2 sm:col-span-2">
        <Label htmlFor="req">Special Requests</Label>
        <Textarea id="req" rows={3} value={form.special_requests} onChange={set("special_requests")} data-testid="itin-requests" placeholder="Honeymoon, dietary needs, pace, anything…" />
      </div>
      <div className="sm:col-span-2">
        <Button disabled={loading} type="submit" className="rounded-full w-full h-12" data-testid="itin-submit">
          {loading ? "Sending…" : "Send my request"}
        </Button>
      </div>
    </form>
  );
}
